import { Trans, t } from "@lingui/macro";
import { ComponentProps } from "react";

import ExternalLink from "components/ExternalLink/ExternalLink";
import TooltipWithPortal from "components/Tooltip/TooltipWithPortal";

export function FeeApyLabel({
  upperCase = false,
  variant = "underline",
}: {
  upperCase?: boolean;
  variant?: ComponentProps<typeof TooltipWithPortal>["variant"];
}) {
  const label = t`Fee APY`;
  return (
    <TooltipWithPortal
      handle={upperCase ? label.toUpperCase() : label}
      className="normal-case"
      position="bottom-end"
      variant={variant}
      content={
        <Trans>
          Estimated annualized fees generated by trading activity (open, close, borrow, liquidations, swaps) over the
          selected period. Does not include backing token price changes, trading PnL, or funding fees.
          <br />
          <br />
          For detailed stats and comparisons, see the{" "}
          <ExternalLink href="https://dune.com/gmx-io/v2-lp-dashboard">GMX V2 LP Dashboard</ExternalLink>.
        </Trans>
      }
    />
  );
}
